import React from 'react';

const RatingMeter = ({ percentage }) => {
  const meterColors = [
    { color: '#F65A5B', range: [0, 20], image: '../emoji/slightly_frowning_face_3d.png' },
    { color: '#FFA000', range: [21, 40], image: '../emoji/neutral_face_3d.png' },
    { color: '#FFD428', range: [41, 60], image: '../emoji/slightly_smiling_face_3d.png' },
    { color: '#00AD8B', range: [61, 80], image: '../emoji/slightly_smiling_face_3d.png' },
    { color: '#2b9348', range: [81, 100], image: '../emoji/grinning_face_3d.png' },
  ];

  const containerStyle = {
    width: '450px',
    height: '50px',
    backgroundColor: 'transparent',
    borderRadius: '25px',
    position: 'relative',
    display: 'flex',
    marginTop: '20px'
  };

  const renderMeterSegments = () => {
    return meterColors.map((color, index) => (
      <div
        key={index}
        style={{
          height: '100%',
          backgroundColor: color.color,
          width: `${color.range[1] - color.range[0]}%`,
          borderRadius: index === 0 ? '25px 0 0 25px' : index === meterColors.length - 1 ? '0 25px 25px 0' : '0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <img 
          src={color.image} 
          alt={`Rating ${color.range[0]}-${color.range[1]}`} 
          style={{ height: '30px', width: '30px' }}
        />
      </div>
    ));
  };

  const meterStyle = {
    height: '100%',
    borderRadius: '25px',
    backgroundColor: 'transparent',
    transition: 'width 0.5s ease',
  };

  const arrowStyle = {
    position: 'absolute',
    top: '-15px',
    left: `${percentage}%`,
    transform: 'translateX(-50%)',
    width: '0',
    height: '0',
    borderLeft: '15px solid transparent',
    borderRight: '15px solid transparent',
    borderTop: '15px solid #333333',
  };

  return (
    <div style={containerStyle}>
      {renderMeterSegments()}
      <div style={meterStyle}></div>
      <div style={arrowStyle}></div>
    </div>
  );
};

export default RatingMeter;